var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import Elpong from 'elpong';
import { ActivatedRoute } from '@angular/router';
import { ZevensterAjaxService } from '../zevenster-ajax/zevenster-ajax.service';
import { UiService } from '../ui/ui.service';
import { Subject, from } from 'rxjs';
import { filter, merge } from 'rxjs/operators';
var AdminPurchasePageComponent = /** @class */ (function () {
    function AdminPurchasePageComponent(activatedRoute, zevensterAjaxService, ui) {
        var _this = this;
        this.activatedRoute = activatedRoute;
        this.zevensterAjaxService = zevensterAjaxService;
        this.ui = ui;
        this.clickedSquareIds = new Set();
        this.selectedSquareIds = new Set();
        this.clickedSquare$ = new Subject();
        this.clickedSquareFocused$ = this.clickedSquare$.pipe(filter(function (sqId) { return !_this.clickedSquareIds.has(sqId); }));
        this.clickedSquareUnfocused$ = this.clickedSquare$.pipe(filter(function (sqId) { return _this.clickedSquareIds.has(sqId); }));
        this.activatedRoute.paramMap.subscribe(function (paramMap) { return __awaiter(_this, void 0, void 0, function () {
            var uid, _a, _i, _b, a;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        uid = paramMap.get('purchase_uid');
                        if (!uid) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.zevensterAjaxService.fetchPurchase(parseInt(uid), true)];
                    case 1:
                        _a.purchase = _c.sent();
                        for (_i = 0, _b = this.purchase.fields.areas; _i < _b.length; _i++) {
                            a = _b[_i];
                            this.selectedSquareIds.add(a);
                            this.clickedSquareIds.add(a);
                        }
                        this.focusedSquare$ = from(this.purchase.fields.areas)
                            .pipe(merge(this.clickedSquareFocused$));
                        return [3 /*break*/, 3];
                    case 2:
                        this.purchase = Elpong.get('greenplease').select('zevenster_purchases').build({});
                        this.focusedSquare$ = this.clickedSquareFocused$;
                        _c.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
    }
    AdminPurchasePageComponent.prototype.onSubmit = function () {
        this.purchase.fields.areas = Array.from(this.selectedSquareIds);
        this.purchase.fields.total_area = this.purchase.fields.areas.length;
        this.purchase.fields.paid = true;
        this.purchase.fields.added_by_admin = true;
        this.purchase.save().then(function () {
            alert('Opslaan gelukt.');
            window.location.reload();
        });
    };
    AdminPurchasePageComponent.prototype.clickSquare = function (squareId) {
        this.clickedSquare$.next(squareId);
        if (this.clickedSquareIds.has(squareId)) {
            this.clickedSquareIds.delete(squareId);
        }
        else {
            this.clickedSquareIds.add(squareId);
        }
    };
    AdminPurchasePageComponent.prototype.selectSquare = function (squareId) {
        if (this.selectedSquareIds.has(squareId)) {
            this.selectedSquareIds.delete(squareId);
        }
        else {
            this.selectedSquareIds.add(squareId);
        }
    };
    AdminPurchasePageComponent.prototype.getTotalPrice = function () {
        return Math.ceil(this.selectedSquareIds.size * 40 / 9);
    };
    AdminPurchasePageComponent.prototype.removeArea = function () {
        if (confirm("Wilt u zeker het stuk bos van deze persoon verwijderen? U kan hierna een nieuw stuk aanklikken."))
            this.purchase.actions.deleteArea().then(function () {
                alert("Stuk bos verwijderd.");
                window.location.reload();
            });
    };
    AdminPurchasePageComponent.prototype.ngOnInit = function () {
    };
    AdminPurchasePageComponent.prototype.ngAfterViewInit = function () {
        this.ui.whitened$.next(true);
    };
    AdminPurchasePageComponent.prototype.ngOnDestroy = function () {
        this.ui.whitened$.next(false);
    };
    return AdminPurchasePageComponent;
}());
export { AdminPurchasePageComponent };
//# sourceMappingURL=admin-purchase-page.component.js.map